const DOLLAR = '\u0024'

export function formatUsd(amount: number): string {
  const rounded = Math.round(amount * 100) / 100
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2)
}

/** 6.39 -> "$6.39" */
export function usd(amount: number): string {
  return DOLLAR + formatUsd(amount)
}

export function sumUsd(...amounts: number[]): number {
  return Math.round(amounts.reduce((acc, n) => acc + n, 0) * 100) / 100
}
